import * as user from './user';
import * as account from './account';
import * as endpoint from "./endpoint";
import * as types from '../actions/types'


/**
 * createReducer creates a Store level 'master' reducer that delegates to another action-specific reducer
 * The action-specific reducers are passed in as 'handlers'.  handlers is an object with action.type properties
 * and a reducer function for that action type as the property value.
 *
 * If an action has an 'effect' property that is a function, effect() is called prior to the action being passed
 * to the handler.  If the effect function returns a "truthy" value, the action is not processed and the current
 * state is returned.  This allows the effect function to cancel further processing.
 *
 * @param handlers
 * @returns {function(...[*]=)}
 */
const createReducer = handlers => (state, action) => {

    // We can't find a handler for the passed action type, return the state as is.
    if (!handlers.hasOwnProperty(action.type)) {
        //console.warn('handler not found for ', action);
        return state;
    }

    // If the action has an effect - call it
    if (typeof(action.effect) === 'function' ) {
        // If the action effect returns false, then don't execute the action
        const cancel = action.effect();
        if (cancel) {
            return state;
        }
    }

    //console.log('processing action:', action)

    // Otherwise run the reducer for the action type to modify and return the state.
    const newState = handlers[action.type](state, action);
    //console.log('post-action state:', newState);
    return newState;
};

// Create a reducer function that delegates to action-specific reducer functions.
export default createReducer({
    [types.SET_USER]: user.set,
    [types.CLEAR_USER]: user.clear,
    [types.SET_ACCOUNT]: account.set,
    [types.CLEAR_ACCOUNT]: account.set,
    [types.FETCH_ACCOUNT]: account.fetch,
    [types.RECEIVE_ACCOUNT]: account.receive,
    [types.INVALIDATE_ACCOUNT]: account.invalidate,
    [types.SET_ACCOUNT_PAYMENT_METHOD]: account.setPaymentMethod,
    [types.SET_SERVICES]: account.setServices,
    [types.SET_ENDPOINT]: endpoint.set,
    [types.CLEAR_ENDPOINT]: endpoint.clear,
})